import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuDropDown = () => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  return (
    <>
      <li
        className="nav-item dropdown "
        onMouseEnter={() => setDropdownVisible(true)}
        onMouseLeave={() => setDropdownVisible(false)}
      >
        <a className="nav-link nav-pad dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>Services</a>
        {isOpen && (
          <div className=" p-2 mobile-dropdown">
            <li style={{borderBottom:"1px solid"}} className="dropdown-header fw-bold fs-5">
              Strategic Services
            </li>
            <li style={{padding:"10px"}}> 
              <Link to="/Technology-Consulting-Services" className="dropdown-item">
                Technology Consulting Services
              </Link>
            </li>
            <li style={{padding:"10px"}}>
              <Link to="/services" className="dropdown-item">
                Strategy Consulting & Designs
              </Link>
            </li>
            <li style={{padding:"10px"}}>
              <Link to="/workforce-strategy-and-plans" className="dropdown-item">
                Workforce Strategy & Plans
              </Link>
            </li>

            <li className="dropdown-header" style={{borderBottom:"1px solid"}}>Managed Services</li>
                <li style={{padding:"10px"}}>
                  <Link className="dropdown-item" to="/Application-and-product-maintanence">
                    Application & Product Management
                  </Link>
                </li>
                <li style={{padding:"10px"}}>
                  <Link className="dropdown-item" to="/CloudOps">
                    CloudOps
                  </Link>
                </li>

          </div>
        )}


        {dropdownVisible && (
          <ul className="dropdown-menu show custom-dropdown p-3">
            <div className="row">
              {/* First Column */}
              <div className="col-md-6">
                <li className="dropdown-header fw-bold fs-5">
                  Strategic Services
                </li>
                <li>
                  <Link to="/Technology-Consulting-Services" className="dropdown-item">
                    Technology Consulting Services
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="dropdown-item">
                    Strategy Consulting & Designs
                  </Link>
                </li>
                <li>
                  <Link to="/workforce-strategy-and-plans" className="dropdown-item">
                    Workforce Strategy & Plans
                  </Link>
                </li>
              </div>

              {/* Second Column */}
              <div className="col-md-6">
                <li className="dropdown-header">Managed Services</li>
                <li>
                  <Link className="dropdown-item" to="/Application-and-product-maintanence">
                    Application & Product Management
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/CloudOps">
                    CloudOps
                  </Link>
                </li>
              </div>
            </div>
          </ul>
        )}
      </li>
    </>
  );
};

export default MenuDropDown;
